import React from 'react';
import { Shield, Users, Activity, Power, ScrollText, Bug, Rocket, Clock, AlertTriangle, Plug } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';

// Import refactored tab components
import UsersTab from '../components/admin/UsersTab';
import HealthTab from '../components/admin/HealthTab';
import ControlsTab from '../components/admin/ControlsTab';
import LogsTab from '../components/admin/LogsTab';
import BugsTab from '../components/admin/BugsTab';
import DeploysTab from '../components/admin/DeploysTab';
import AuditTab from '../components/admin/AuditTab';
import DangerZoneTab from '../components/admin/DangerZoneTab';
import IntegrationsTab from '../components/admin/IntegrationsTab';

const Admin: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <div className="flex items-center gap-3">
          <Shield className="w-7 h-7 text-foreground" />
          <div>
            <h1 className="text-2xl font-bold">Admin Panel</h1>
            <p className="text-sm text-muted-foreground">Platform management, users, health, controls, and audit</p>
          </div>
        </div>
      </div>

      <Tabs defaultValue="users" className="space-y-4">
        <TabsList className="flex-wrap h-auto p-1 bg-muted/50">
          <TabsTrigger value="users" className="gap-1.5 py-1.5 px-3 data-[state=active]:bg-background">
            <Users className="w-3.5 h-3.5" /> Users
          </TabsTrigger>
          <TabsTrigger value="health" className="gap-1.5 py-1.5 px-3 data-[state=active]:bg-background">
            <Activity className="w-3.5 h-3.5" /> Health
          </TabsTrigger>
          <TabsTrigger value="integrations" className="gap-1.5 py-1.5 px-3 data-[state=active]:bg-background">
            <Plug className="w-3.5 h-3.5" /> Integrations
          </TabsTrigger>
          <TabsTrigger value="controls" className="gap-1.5 py-1.5 px-3 data-[state=active]:bg-background">
            <Power className="w-3.5 h-3.5" /> Controls
          </TabsTrigger>
          <TabsTrigger value="logs" className="gap-1.5 py-1.5 px-3 data-[state=active]:bg-background">
            <ScrollText className="w-3.5 h-3.5" /> Logs
          </TabsTrigger>
          <TabsTrigger value="bugs" className="gap-1.5 py-1.5 px-3 data-[state=active]:bg-background">
            <Bug className="w-3.5 h-3.5" /> Bugs
          </TabsTrigger>
          <TabsTrigger value="deploys" className="gap-1.5 py-1.5 px-3 data-[state=active]:bg-background">
            <Rocket className="w-3.5 h-3.5" /> Deploys
          </TabsTrigger>
          <TabsTrigger value="audit" className="gap-1.5 py-1.5 px-3 data-[state=active]:bg-background">
            <Clock className="w-3.5 h-3.5" /> Audit
          </TabsTrigger>
          <TabsTrigger value="danger" className="gap-1.5 py-1.5 px-3 data-[state=active]:bg-background text-rose-600 data-[state=active]:text-rose-600">
            <AlertTriangle className="w-3.5 h-3.5" /> Danger Zone
          </TabsTrigger>
        </TabsList>

        <div className="mt-4">
          <TabsContent value="users"><UsersTab /></TabsContent>
          <TabsContent value="health"><HealthTab /></TabsContent>
          <TabsContent value="integrations"><IntegrationsTab /></TabsContent>
          <TabsContent value="controls"><ControlsTab /></TabsContent>
          <TabsContent value="logs"><LogsTab /></TabsContent>
          <TabsContent value="bugs"><BugsTab /></TabsContent>
          <TabsContent value="deploys"><DeploysTab /></TabsContent>
          <TabsContent value="audit"><AuditTab /></TabsContent>
          <TabsContent value="danger"><DangerZoneTab /></TabsContent>
        </div>
      </Tabs>
    </div>
  );
};

export default Admin;
